function fireEvent(action) {
	const e = document.createEvent('CustomEvent');
	e.initCustomEvent('acom-track-event', true, true, { action });
	if (action === 'signup succeed') {
		e.initCustomEvent('acom-track-mixpanel', true, true, { action });
	}
	window.dispatchEvent(e);
}

export default fireEvent;
